import { t } from "@bookingcom/lingojs-core";
export const PREMIUM_SEAT_FEATURES = new Set(["PREMIUM_SEAT"]);
export const BASIC_SEAT_FEATURES = new Set(["BASIC_SEAT", "PRE_RESERVED_SEAT_ASSIGNMENT"]);
export const PRIORITY_FEATURES = new Set([
    "PRIORITY_BAGGAGE",
    "PRIORITY_CHECK_IN",
    "PRIORITY_BOARDING",
    "PRIORITY_SECURITY"
]);
export const REFUND_FEATURES = new Set([
    "REFUNDABLE_TICKET",
    "REFUND_AFTER_DEPARTURE",
    "REFUND_BEFORE_DEPARTURE"
]);
export const FLEXIBILITY_FEATURES = new Set([
    "CHANGE_ANYTIME",
    "CHANGE_AFTER_DEPARTURE",
    "CHANGE_BEFORE_DEPARTURE",
    "CHANGEABLE_TICKET",
    "SAME_DAY_CHANGE",
    "SAME_DAY_AS_ORIGINAL_FLT"
]);
const hasFeature = (features, featureSet) => features.some(({ featureName }) => featureSet.has(featureName));
const getCheckedBagPiecePerPax = (includedProducts) => {
    if (!includedProducts?.segments?.[0])
        return 0;
    const checkedBag = includedProducts.segments[0].find((item) => item.luggageType === "CHECKED_IN");
    if (!checkedBag)
        return 0;
    return checkedBag.piecePerPax ?? checkedBag.maxPiece ?? 0;
};
const detectFeatures = (features, sellableFeatures, includedProducts) => {
    const flags = {
        refundable: false,
        flexibility: false,
        partialRefund: false,
        partialFlexibility: false,
        multipleCheckedBags: false,
        checkInBag: false,
        premiumSeat: false,
        priority: false,
        basicSeat: false
    };
    flags.refundable = hasFeature(features, REFUND_FEATURES);
    flags.flexibility = hasFeature(features, FLEXIBILITY_FEATURES);
    flags.partialRefund = !flags.refundable && hasFeature(sellableFeatures, REFUND_FEATURES);
    flags.partialFlexibility = !flags.flexibility && hasFeature(sellableFeatures, FLEXIBILITY_FEATURES);
    const hasCheckedBag = features.some(({ featureName }) => featureName === "CHECK_BAGGAGE");
    if (hasCheckedBag) {
        const piecePerPax = getCheckedBagPiecePerPax(includedProducts);
        flags.multipleCheckedBags = piecePerPax >= 2;
        flags.checkInBag = piecePerPax < 2;
    }
    flags.premiumSeat = hasFeature(features, PREMIUM_SEAT_FEATURES);
    flags.priority = hasFeature(features, PRIORITY_FEATURES);
    flags.basicSeat = hasFeature(features, BASIC_SEAT_FEATURES);
    return flags;
};
const getOneLineSummaryCopy = (f, flexibilityOnly = false) => {
    if (f.refundable) {
        return t("flights_bf_one_line_refund");
    }
    if (f.flexibility) {
        return t("flights_bf_one_line_change");
    }
    if (f.partialRefund) {
        return t("flights_bf_one_line_partial_refund");
    }
    if (f.partialFlexibility) {
        return t("flights_bf_one_line_change_fee");
    }
    if (flexibilityOnly) {
        return t("flights_sr_bf_one_line_no_refund");
    }
    if (f.multipleCheckedBags) {
        return t("flights_bf_one_line_extra_checked_bags");
    }
    if (f.checkInBag) {
        return t("flights_bf_one_line_checked_bag");
    }
    if (f.premiumSeat) {
        return t("flights_bf_one_line_premium_set");
    }
    if (f.priority) {
        return t("flights_bf_one_line_prio_service");
    }
    if (f.basicSeat) {
        return t("flights_bf_one_line_seat_selection");
    }
    return t("flights_bf_one_line_basic");
};
export const getBrandedFareOneLineSummaryCopy = (brandedFareInfo, includedProducts, options) => {
    const flags = detectFeatures(brandedFareInfo.features, brandedFareInfo.sellableFeatures || [], includedProducts);
    return getOneLineSummaryCopy(flags, options?.flexibilityOnly);
};
